import React, { useContext, useEffect, useRef, useState } from "react";
import MaterialsRequiresGrid from "./MaterialsRequiresGrid";
import { LoginContext } from "../../contexts/LoginContext";
import ViewPortGridWrapper from "../../containers/ViewPortGridWrapper";
import { Button, makeStyles, TextField } from "@material-ui/core";
import { commonFilter } from "../../constants/StyleConstants";
import useMaterialsRequiresPresenter from "./MaterialsRequiresPresenter";
import DefaultUnrederedGridMessage from "../../containers/DefaultUnrenderedGridMessage";

const useStyles = makeStyles((theme) => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const {
    code,
    setCode,
    name,
    setName,
    validateAndSearch,

    search,

    cleanFilters,
  } = filtersProps;

  return (
    <div className={classes.filters}>
      <TextField
        style={{ width: 170 }}
        margin="dense"
        id="code"
        label="Código Material"
        onChange={(e) => setCode(e.target.value)}
        value={code}
      />

      <TextField
        style={{ width: 180 }}
        margin="dense"
        id="name"
        label="Nombre Material"
        onChange={(e) => setName(e.target.value)}
        value={name}
      />

      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={search}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const MaterialsRequires = () => {
  const tableRef = useRef();
  const { isSupplier } = useContext(LoginContext);
  const {
    firstLoad,
    rows,
    loading,
    gridFunctions,
    ...filtersProps
  } = useMaterialsRequiresPresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
        <MaterialsRequiresGrid
          data={rows}
          loading={loading}
          tableRef={tableRef}
          {...gridFunctions}
        />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default MaterialsRequires;
